import RatingBox from "../RatingBox";
import Footer from "../Footer";
import "./App.css"
import React from "react";

function App() {
  return (
    <React.Fragment>
      <main className="main">
        <RatingBox rateScore={5} title="How did we do?">
          Please let us know how we did with your support request. 
          All feedback is appreciated to help us improve our offering!
        </RatingBox>
      </main>
      <Footer></Footer>
    </React.Fragment>
  );
}

export default App;
